import { graphql } from 'src/graphql';

export const Viewer = graphql(`
  query Viewer {
    viewer {
      _id
      email
      email_verified
      kinde_user_id
      intercomJWT
      location {
        country
      }
      ConnectedTeam {
        _id
        name
        kinde_org_id
        type
        Organisation {
          _id
          settings {
            disallow_multiple_team_sign_on
          }
        }
        users {
          _id
          role
          status
        }
        operational_office
        settings {
          ignore_tracking
          sso_enabled
          privacy_policy {
            value
          }
          billing {
            tracks {
              enabled
            }
            currency {
              code
              symbol
            }
            tax {
              currency_code
              currency_symbol
              tax_label
              tax_rate
              tax_number_label
            }
            location {
              country
            }
            subscription {
              credit {
                remaining
              }
            }
          }
        }
        products {
          track_quota
          pd_track_quota
          insight_stream_quota
          beta_features {
            live_website_test
          }
          track_add_ons {
            ai_mod
            ai_repo
          }
          track_participant_quotas {
            ai_mod
            mod
            survey
            unmod
          }
          features {
            industry_stream {
              enabled
              active_streams
            }
          }
        }
      }
      contact {
        phone {
          mobile
        }
      }
      type {
        client
        researcher
        participant
      }
      researcher {
        ux_length
        onboarding {
          linkedIn
          ux_length
          methods
        }
        certification {
          status
        }
      }
      _default_team
      Teams {
        _id
        name
        kinde_org_id
        active_features
      }
      meta {
        social {
          google {
            id
          }
          linkedin {
            profile_url
          }
        }
        identity {
          firstname
          lastname
        }
      }
      settings {
        language
      }
    }
  }
`);
